import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) return null;

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{ backdropFilter: "blur(16px)", background: "rgba(5,5,5,0.85)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="font-display text-xl md:text-2xl tracking-wider text-white hover:text-gold transition-colors duration-300"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          ELYSIAN <span className="text-gold" style={{ color: "#D4AF37" }}>HEIGHTS</span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          <a
            href="/#about"
            data-testid="nav-about"
            className="text-sm tracking-[0.15em] uppercase text-white/70 hover:text-gold transition-colors duration-300"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            About
          </a>
          <a
            href="/#features"
            data-testid="nav-features"
            className="text-sm tracking-[0.15em] uppercase text-white/70 hover:text-gold transition-colors duration-300"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Features
          </a>
          <a
            href="/#location"
            data-testid="nav-location"
            className="text-sm tracking-[0.15em] uppercase text-white/70 hover:text-gold transition-colors duration-300"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Location
          </a>
          <Link
            to="/register"
            data-testid="nav-register-btn"
            className="px-6 py-2.5 text-xs tracking-[0.2em] uppercase font-semibold transition-all duration-300 hover:-translate-y-0.5"
            style={{
              fontFamily: "'Manrope', sans-serif",
              background: "#D4AF37",
              color: "#000",
            }}
          >
            Register Interest
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden px-6 pb-8 pt-4 flex flex-col gap-6"
          style={{ background: "rgba(5,5,5,0.95)" }}
        >
          <a
            href="/#about"
            onClick={() => setMobileOpen(false)}
            className="text-sm tracking-[0.15em] uppercase text-white/70"
          >
            About
          </a>
          <a
            href="/#features"
            onClick={() => setMobileOpen(false)}
            className="text-sm tracking-[0.15em] uppercase text-white/70"
          >
            Features
          </a>
          <a
            href="/#location"
            onClick={() => setMobileOpen(false)}
            className="text-sm tracking-[0.15em] uppercase text-white/70"
          >
            Location
          </a>
          <Link
            to="/register"
            onClick={() => setMobileOpen(false)}
            className="px-6 py-3 text-xs tracking-[0.2em] uppercase font-semibold text-center"
            style={{ background: "#D4AF37", color: "#000" }}
          >
            Register Interest
          </Link>
        </div>
      )}
    </nav>
  );
};
